import React, { useState, useEffect, useRef } from 'react';
import { Input, Label, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { toast } from 'react-toastify';
import Icon from '@mdi/react';
import { mdiClose } from '@mdi/js';
import './NewHeader.scss'; // Assuming you have a separate CSS file for styles

function NewHeader({ isOpen, toggle, onSubmit }) {
  const [headerTitle, setHeaderTitle] = useState('');
  const inputRef = useRef(null); // Create ref for Input

  // Focus input when modal opens
  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  const handleSave = () => {
    if (!headerTitle.trim()) {
      toast.error('Header name is required', {
        className: 'toast-error',
      });
      return;
    }

    onSubmit({ title: headerTitle }); // Call mutation passed from parent
    setHeaderTitle('');
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      size="xs"
      onOpened={() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }}
    >
      <div className="modal-header-custom px-4 pt-3 pb-2 d-flex justify-content-between align-items-center">
        <h5 className="modal-title mb-0">Add New Faqs</h5>
        <Icon
          path={mdiClose}
          size={1}
          color="#000000"
          onClick={toggle}
          className="cursor-pointer"
        />
      </div>

      <ModalBody className="px-4">
        <div className="mb-3">
          <Label className="form-label">
            Add New Faqs Header<span className="text-danger">*</span>
          </Label>
          <Input
            innerRef={inputRef}
            placeholder="Enter new header here"
            type="text"
            value={headerTitle}
            onChange={e => setHeaderTitle(e.target.value)}
            className="external-filter-input"
          />
        </div>
      </ModalBody>

      <ModalFooter className="px-4">
        <button
          type="button"
          className="custom-btn mx-auto w-100"
          onClick={handleSave}
          disabled={!headerTitle.trim()}
        >
          Add New Header
        </button>
      </ModalFooter>
    </Modal>
  );
}

export default NewHeader;
